import { parseAppointmentMoment } from './appointmentDisplayUtils';

const DESCRIPTION_TEMPLATE = `Telehealth appointment for [patient name] has been confirmed.

The appointment is booked on [Time] - [Day]/[Month]/[Year].`;

const CALENDAR_DATE_FORMAT = 'YYYYMMDDTHHmmss';
const GOOGLE_CALENDAR_BASE_URL = 'https://calendar.google.com/calendar/render';

const toCalendarDate = (appointmentMoment) =>
  `${appointmentMoment.clone().utc().format(CALENDAR_DATE_FORMAT)}Z`;

export const generateCalendarEvent = (workflow) => {
  const { client, specialist, appointment } = workflow || {};
  const startMoment = parseAppointmentMoment(appointment?.startDateTime);
  const endMoment = parseAppointmentMoment(appointment?.endDateTime);

  if (!startMoment || !endMoment || !client || !specialist) return null;

  const patientName = `${client.firstName || ''} ${
    client.lastName || ''
  }`.trim();
  const practitionerName = `${specialist.firstName || ''} ${
    specialist.lastName || ''
  }`.trim();

  const description = DESCRIPTION_TEMPLATE.replace(
    '[patient name]',
    patientName
  )
    .replace('[Time]', startMoment.format('HH:mm'))
    .replace('[Day]', startMoment.format('DD'))
    .replace('[Month]', startMoment.format('MM'))
    .replace('[Year]', startMoment.format('YYYY'));

  return {
    title: `Appointment with Dr ${practitionerName} from Telecare`,
    description,
    dates: `${toCalendarDate(startMoment)}/${toCalendarDate(endMoment)}`,
  };
};

export const buildGoogleCalendarUrl = (event) => {
  if (!event) return '';

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    details: event.description,
    dates: event.dates,
  });

  return `${GOOGLE_CALENDAR_BASE_URL}?${params.toString()}`;
};
